/* unplugin-vue-components disabled */import { render } from "./button-group.vue?vue&type=template&id=07506e54&scoped=true"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"

import "./button-group.vue?vue&type=style&index=0&id=07506e54&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07506e54"],['__file',"src/controls/button-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07506e54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07506e54', __exports__)) {
    api.reload('07506e54', __exports__)
  }
  
  module.hot.accept("./button-group.vue?vue&type=template&id=07506e54&scoped=true", () => {
    api.rerender('07506e54', render)
  })

}


export default __exports__